import { useContext, useEffect } from "react";
import AuthenticationContext, {
  AuthenticationState,
} from "../contexts/auth/AuthenticationContext";
import "./StartLayout.css";
import { Outlet } from "react-router-dom";
import LoadingCurtain from "../components/@shared/LoadingCurtain";
import { OVERVIEW_PAGE_PATH } from "../pages/OverviewPage";
import { useNavigate } from "react-router-dom";

const StartLayout: React.FC = () => {
  const authContext = useContext(AuthenticationContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (authContext.authenticationState === AuthenticationState.AUTHENTICATED) {
      navigate(OVERVIEW_PAGE_PATH);
    }
  }, [authContext.authenticationState]);

  return authContext.authenticationState !==
    AuthenticationState.UNAUTHENTICATED ? (
    <LoadingCurtain />
  ) : (
    <div className="start-layout">
      <Outlet />
    </div>
  );
};

export default StartLayout;
